export default {
  setCashAccounts(state, data) {
    state.cashAccounts = data;
  },
  setCashAccount(state, data) {
    state.cashAccount = data;
  },
  setCashAccountId(state, data) {
    state.cashAccountId = data;
  },
  setCashAccountCode(state, data) {
    state.cashAccountCode = data;
  },
  setCashAccountVoucher(state, data) {
    state.cashAccountVoucher = data;
  },

  setBankAccounts(state, data) {
    state.bankAccounts = data;
  },
  setBankAccount(state, data) {
    state.bankAccount = data;
  },
  setBankAccountId(state, data) {
    state.bankAccountId = data;
  },
  setBankAccountCode(state, data) {
    state.bankAccountCode = data;
  },
  setBankAccountVoucher(state, data) {
    state.bankAccountVoucher = data;
  },

  setChequeStatuses(state, data) {
    state.chequeStatuses = data;
  },
  setChequeBatch(state, data) {
    state.chequeBatch = data;
  },

  setChequeBatchCode(state, data) {
    state.chequeBatchCode = data;
  },

  setChequeBatchDetail(state, date) {
    state.chequeBatchDetail = date;
  },

  setChequeBatchDetailByNumber(state, date) {
    state.chequeBatchDetailByNumber = date;
  },

  setPaymentChequeDetailByNumber(state, date) {
    state.paymentChequeDetailByNumber = date;
  },

  setReceiveCashes(state, data) {
    state.receiveCashes = data;
  },
  setReceiveCash(state, data) {
    state.receiveCash = data;
  },
  setReceiveCashId(state, data) {
    state.receiveCashId = data;
  },
  setReceiveCashVoucherId(state, data) {
    state.receiveCashVoucherId = data;
  },

  setReceiveCashCode(state, data) {
    state.receiveCashCode = data;
  },

  setReceiveCashNavigation(state, data) {
    state.receiveCashNavigation = data;
  },

  setReceiveCashCheckDelete(state, data) {
    state.receiveCashCheckDelete = data;
  },

  setReceiveCashVoucher(state, data) {
    state.receiveCashVoucher = data;
  },
  setReceiveVoucherNumber(state, data) {
    state.receiveVoucherNumber = data;
  },
  setReceiveVoucherId(state, data) {
    state.receiveVoucherId = data;
  },

  setPaymentCashes(state, data) {
    state.paymentCashes = data;
  },
  setPaymentCash(state, data) {
    state.paymentCash = data;
  },
  setPaymentCashId(state, data) {
    state.paymentCashId = data;
  },

  setPaymentCashCode(state, data) {
    state.paymentCashCode = data;
  },

  setPaymentCashNavigation(state, data) {
    state.paymentCashNavigation = data;
  },

  setPaymentCashCheckDelete(state, data) {
    state.paymentCashCheckDelete = data;
  },
  setPaymentVoucherNumber(state, data) {
    state.paymentVoucherNumber = data;
  },
  setPaymentVoucherId(state, data) {
    state.paymentVoucherId = data;
  },

  setRequestPayments(state, data) {
    state.requestPayments = data;
  },
  setRequestPayment(state, data) {
    state.requestPayment = data;
  },
  setRequestPaymentCode(state, data) {
    state.requestPaymentCode = data;
  },
  setRequestPaymentNavigation(state, data) {
    state.requestPaymentNavigation = data;
  },

  setPaymentCashVoucher(state, data) {
    state.paymentCashVoucher = data;
  },

  setReceiveCheques(state, data) {
    state.receiveCheques = data;
  },
  setReceiveChequeCreateCheck(state, data) {
    state.receiveChequeCreateCheck = data;
  },
  setReceiveCheque(state, data) {
    state.receiveCheque = data;
  },

  setReceiveChequeCode(state, data) {
    state.receiveChequeCode = data;
  },

  setReceiveChequeId(state, data) {
    state.receiveChequeId = data;
  },

  setReceiveChequeData(state, data) {
    state.receiveChequeData = data;
  },

  setReceiveChequeBackNumber(state, data) {
    state.receiveChequeBackNumber = data;
  },

  setReceiveChequeBankTransfer(state, data) {
    state.receiveChequeBankTransfer = data;
  },

  setTransactionInfo(state, data) {
    state.transactionInfo = data;
  },

  setReceiveChequeSampleExcel(state, data) {
    state.receiveChequeSampleExcel = data;
  },

  setReceiveChequeCartable(state, data) {
    state.receiveChequeCartable = data;
  },

  setReceiveChequeVoucher(state, data) {
    state.receiveChequeVoucher = data;
  },

  setReceiveChequeNavigation(state, data) {
    state.receiveChequeNavigation = data;
  },


  setBankTransfers(state, data) {
    state.bankTransfers = data;
  },
  setBankTransferIds(state, data) {
    state.bankTransferIds = data;
  },

  setAssignmentPersons(state, data) {
    state.assignmentPersons = data;
  },
  setAssignmentPersonIds(state, data) {
    state.assignmentPersonIds = data;
  },

  setSettlements(state, data) {
    state.settlements = data;
  },

  setReturnTransferreds(state, data) {
    state.returnTransferreds = data;
  },

  setCancellationReceivables(state, data) {
    state.cancellationReceivables = data;
  },

  setReturnReceivables(state, data) {
    state.returnReceivables = data;
  },
  setReturnReceivableIds(state, data) {
    state.returnReceivableIds = data;
  },

  setReturnGuarantees(state, data) {
    state.returnGuarantees = data;
  },

  setReturnAssignments(state, data) {
    state.returnAssignments = data;
  },
  setReturnAssignmentIds(state, data) {
    state.returnAssignmentIds = data;
  },

  setRequestPaymentConfirm(state, data) {
    state.requestPaymentConfirm = data;
  },

  setReceiveChequeTurns(state, data) {
    state.receiveChequeTurns = data;
  },
  setReceiveChequeTurn(state, data) {
    state.receiveChequeTurn = data;
  },

  setPaymentCheques(state, data) {
    state.paymentCheques = data;
  },
  setPaymentCheque(state, data) {
    state.paymentCheque = data;
  },
  setPaymentChequeId(state, data) {
    state.paymentChequeId = data;
  },

  setPaymentChequeData(state, data) {
    state.paymentChequeData = data;
  },

  setPaymentChequeCode(state, data) {
    state.paymentChequeCode = data;
  },

  setPaymentChequeNavigation(state, data) {
    state.paymentChequeNavigation = data;
  },

  setPaymentChequeCartable(state, data) {
    state.paymentChequeCartable = data;
  },

  setPaymentChequeCheckDelete(state, data) {
    state.paymentChequeCheckDelete = data;
  },

  setPaymentChequeSampleExcel(state, data) {
    state.paymentChequeSampleExcel = data;
  },

  setPaymentChequeVoucher(state, data) {
    state.paymentChequeVoucher = data;
  },

  setPaymentChequeTurns(state, data) {
    state.paymentChequeTurns = data;
  },
  setPaymentChequeTurn(state, data) {
    state.paymentChequeTurn = data;
  },

  setPassPayDocs(state, data) {
    state.passPayDocs = data;
  },

  setCancelPayableDocs(state, data) {
    state.cancelPayableDocs = data;
  },

  setReturnGuaranteeDocs(state, data) {
    state.returnGuaranteeDocs = data;
  },

  setReceiveChequeReport(state, data) {
    state.receiveChequeReport = data;
  },

  setReceiveCashAndCahPaymentReport(state, data) {
    state.receiveCashAndCahPaymentReport = data;
  },

  setCashAndChequeOperationDetailReport(state, data) {
    state.cashAndChequeOperationDetailReport = data;
  },

  setMonthlyComparisonReceiveAndPaymentCashReport(state, data) {
    state.monthlyComparisonReceiveAndPaymentCashReport = data;
  },

  setHistoryReceiveChequeReport(state, data) {
    state.historyReceiveChequeReport = data;
  },

  setDueReceiveChequeReport(state, data) {
    state.dueReceiveChequeReport = data;
  },

  setMonthlyComparisonReceiveChequeReport(state, data) {
    state.monthlyComparisonReceiveChequeReport = data;
  },
  setSummaryReceiveChequeReport(state, data) {
    state.summaryReceiveChequeReport = data;
  },

  setPaymentChequeReport(state, data) {
    state.paymentChequeReport = data;
  },
  setHistoryPaymentChequeReport(state, data) {
    state.historyPaymentChequeReport = data;
  },
  setMonthlyComparisonPaymentChequeReport(state, data) {
    state.monthlyComparisonPaymentChequeReport = data;
  },
  setPaymentChequeToPersonReport(state, data) {
    state.paymentChequeToPersonReport = data;
  },
  setPaymentChequeToAccountInfoReport(state, data) {
    state.paymentChequeToAccountInfoReport = data;
  },
  setPaymentChequeTurnReport(state, data) {
    state.paymentChequeTurnReport = data;
  },
  setSummaryPaymentChequeReport(state, data) {
    state.summaryPaymentChequeReport = data;
  },
  setOverduePaymentChequeReport(state, data) {
    state.overduePaymentChequeReport = data;
  },

  setCirculationVoucherReport(state, data) {
    state.circulationVoucherReport = data;
  },

  setCashFlowReport(state, data) {
    state.cashFlowReport = data;
  },
  setCashFlowTableTwoReport(state, data) {
    state.cashFlowTableTwoReport = data;
  },

  setAccountInventoryReport(state, data) {
    state.accountInventoryReport = data;
  },
  setSummaryPaymentChequeTab(state, data) {
    state.summaryPaymentChequeTab = data;
  },
  setSummaryReceiveChequeTab(state, data) {
    state.summaryReceiveChequeTab = data;
  },
  setSummaryReceiveAndPaymentCash(state, data) {
    state.summaryReceiveAndPaymentCash = data;
  },

  setReceiveAndPayment(state, data) {
    state.receiveAndPayment = data;
  },
  setReceiveAndPaymentById(state, data) {
    state.receiveAndPaymentById = data;
  },
  setReceiveAndPaymentMaxCode(state, data) {
    state.receiveAndPaymentMaxCode = data;
  },
  setIssueTrackingTypes(state, data) {
    state.issueTrackingTypes = data;
  },
  setReceiptRecevied(state, data) {
    state.receiptRecevied = data;
  },
  setReceiptReceviedById(state, data) {
    state.receiptReceviedById = data;
  },
  setReceiptReceviedMaxCode(state, data) {
    state.receiptReceviedMaxCode = data;
  },
  setReceiptReceviedNavigation(state, data) {
    state.receiptReceviedNavigation = data;
  },
  setExportReceivedPaper(state, data) {
    state.exportReceivedPaper = data;
  },

  setPaymentPaper(state, data) {
    state.paymentPaper = data;
  },
  setPaymentPaperById(state, data) {
    state.paymentPaperById = data;
  },
  setPaymentPaperMaxCode(state, data) {
    state.paymentPaperMaxCode = data;
  },
  setPaymentPaperNavigation(state, data) {
    state.paymentPaperNavigation = data;
  },
  setExportPaymentPaper(state, data) {
    state.exportPaymentPaper = data;
  },

  setPaymentChequeManagementCartable(state, data) {
    state.paymentChequeManagementCartable = data;
  },
  setRequestPaymentManagementCartable(state, data) {
    state.requestPaymentManagementCartable = data;
  },
  setReceiveChequeManagementCartable(state, data) {
    state.receiveChequeManagementCartable = data;
  },

  setCartableLog(state, data) {
    state.cartableLog = data;
  },

  setPbankAttachs(state, data) {
    state.pbankAttachs = data;
  },

  setDashboardSixPieCharts(state, data) {
    state.dashboardSixPieCharts = data;
  },
  setFirstLineChart(state, data) {
    state.firstLineChart = data;
  },
  setSecondLineChart(state, data) {
    state.secondLineChart = data;
  },
  setThirdLineChart(state, data) {
    state.thirdLineChart = data;
  },
  setFourthLineChart(state, data) {
    state.fourthLineChart = data;
  },
  setFifthLineChart(state, data) {
    state.fifthLineChart = data;
  },
  setSixthLineChart(state, data) {
    state.sixthLineChart = data;
  },
  setPrintLink(state, data) {
    state.printLink = data;
  },

  setInterBankTransfer(state, data) {
    state.interBankTransfer = data;
  },
  setInterBankTransferItem(state, data) {
    state.interBankTransferItem = data;
  },
  setInterBankTransferNavigation(state, data) {
    state.interBankTransferNavigation = data;
  },
  setBankTransferMaxCode(state, data) {
    state.bankTransferMaxCode = data;
  },
  setInterBankTransferId(state, data) {
    state.interBankTransferId = data;
  },
  setInterBankTransferVoucher(state, data) {
    state.interBankTransferVoucher = data;
  },
  setBankTransferCheckDelete(state, data) {
    state.bankTransferCheckDelete = data;
  },
  setBankTransferVoucherNumber(state, data) {
    state.bankTransferVoucherNumber = data;
  },
  setBankTransferVoucherId(state, data) {
    state.bankTransferVoucherId = data;
  },
};
